import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function EmotionalHook() {
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-cream" data-id="element-56">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-57">
        <h2 className="font-playfair text-2xl sm:text-3xl md:text-5xl font-bold text-burgundy text-center mb-6 md:mb-12" data-id="element-58">
          La scène que tu veux vivre dimanche matin
        </h2>

        <div className="space-y-4 md:space-y-6 text-base sm:text-lg md:text-xl text-gray-700 font-lato leading-relaxed mb-8 md:mb-12" data-id="element-59">
          <p data-id="element-60">
            Tu arrives chez elle avec une boîte blanche, fermée par un ruban de
            satin parfait, et un petit mot doux.
          </p>
          <p data-id="element-61">Elle l'ouvre.</p>
          <p data-id="element-62">Et là… silence.</p>
          <p data-id="element-63">
            Ses yeux s'arrêtent sur 10 fraises magiques, si brillantes qu'elles
            semblent sortir d'une boutique de luxe.
          </p>
          <p data-id="element-64">Elle te regarde avec une incrédulité mêlée de fierté.</p>
          <p className="font-bold text-burgundy text-lg sm:text-xl md:text-2xl" data-id="element-65">
            C'est ça, le vrai cadeau. Ce silence d'admiration.
          </p>
        </div>

        <div className="text-center" data-id="element-66">
          <CTAButton scrollTo="pack-pricing" subtitle="Accès immédiat — 9,97$ seulement" data-id="element-67">
            JE VEUX CRÉER CE MOMENT 🍓
          </CTAButton>
        </div>
      </motion.div>
    </section>;
}